// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__OrCuB {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 992px) {
  .styles_wrapper__OrCuB {
    display: none;
  }
}

.styles_heading__Klpfb {
  font-weight: 800;
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: #ffffff;
}

.styles_btnWrapper__dVfJ7 {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.styles_buttonsBlock__vO8aL {
  position: relative;
  height: 100%;
  min-height: 46px;
  width: 100%;
  max-width: 215px;
}

.styles_buyBtn__fGOn- {
  position: absolute;
  left: -160px;
}

.styles_payment__u-CWo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
@media (max-width: 576px) {
  .styles_payment__u-CWo {
    top: unset;
    bottom: 0;
    transform: translate(-50%, 0);
    height: 80vh;
    overflow-y: scroll;
  }
  .styles_payment__u-CWo iframe {
    width: 100vh !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pageWrapper/pageHeader/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAFF;ACqBE;EDtBF;IAMI,aAAA;EADF;AACF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,cEnBM;AFkBR;;AAIA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AADF;ACRE;EDKF;IAOI,UAAA;IACA,SAAA;IACA,6BAAA;IAEA,YAAA;IACA,kBAAA;EADF;EAGE;IACE,uBAAA;EADJ;AACF","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  @include lg {\n    display: none;\n  }\n}\n\n.heading {\n  font-weight: 800;\n  font-size: 32px;\n  line-height: 40px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white;\n}\n\n.btnWrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.buttonsBlock {\n  position: relative;\n  height: 100%;\n  min-height: 46px;\n  width: 100%;\n  max-width: 215px;\n}\n\n.buyBtn {\n  position: absolute;\n  left: -160px;\n}\n\n.payment {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  @include sm {\n    top: unset;\n    bottom: 0;\n    transform: translate(-50%, 0);\n\n    height: 80vh;\n    overflow-y: scroll;\n\n    iframe {\n      width: 100vh !important;\n    }\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__OrCuB`,
	"heading": `styles_heading__Klpfb`,
	"btnWrapper": `styles_btnWrapper__dVfJ7`,
	"buttonsBlock": `styles_buttonsBlock__vO8aL`,
	"buyBtn": `styles_buyBtn__fGOn-`,
	"payment": `styles_payment__u-CWo`
};
export default ___CSS_LOADER_EXPORT___;
